import { render } from "./FortschrittsAnzeige.vue?vue&type=template&id=4486405e"
import script from "./FortschrittsAnzeige.vue?vue&type=script&lang=js"
export * from "./FortschrittsAnzeige.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__